import { render } from "./AllUser.vue?vue&type=template&id=2edf39f4"
import script from "./AllUser.vue?vue&type=script&lang=js"
export * from "./AllUser.vue?vue&type=script&lang=js"

import "./AllUser.vue?vue&type=style&index=0&id=2edf39f4&lang=css"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__